import { Checkbox, Flex } from "@mantine/core";
import { type ChangeEvent, useMemo } from "react";
import { getVerifyFromSummary } from "src/components/pages/Summary/VerifyEntries/VerifyEntries.utils";
import type { ISummaryItem } from "src/pages/Summary/Summary.types";
import { useDispatch, useSelector } from "src/redux/hooks";
import { addToVerify, removeFromVerify } from "src/redux/slices/verifySlice";
import { StyledTd } from "src/styled";

interface Props {
  row: ISummaryItem;
  red?: boolean;
}
const SelectCell = ({ row, red }: Props) => {
  const dispatch = useDispatch();
  const { toVerify } = useSelector(state => state.verifySlice);

  const handleSelect = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    const item = getVerifyFromSummary(row);
    if (checked) dispatch(addToVerify(item));
    else dispatch(removeFromVerify(item));
  };

  const selected = useMemo(
    () =>
      toVerify.some(
        e =>
          (e.idType === "lbeid" && e.id === row.lbeid) ||
          (e.idType === "partid" && e.id === row.partid) ||
          (e.idType === "meid" && e.id === row.meid),
      ),
    [toVerify, row.lbeid, row.partid, row.meid],
  );

  return (
    <StyledTd red={red}>
      <Flex gap="sm" justify="center" align="center">
        <Checkbox checked={selected} onChange={handleSelect} />
      </Flex>
    </StyledTd>
  );
};
export default SelectCell;
